module.exports = __webpack_public_path__ + "img/bell.79dd9d47.svg";